import type { SectionsCatalogViewMode } from "./sectionsCatalogView";

export const SECTIONS_CATALOG_VIEW_MODE_STORAGE_KEY = "m360.sections-catalog.view-mode";

const isSectionsCatalogViewMode = (value: unknown): value is SectionsCatalogViewMode =>
  value === "browse" || value === "list";

export function readStoredSectionsCatalogViewMode(): SectionsCatalogViewMode {
  try {
    const stored = window.localStorage.getItem(SECTIONS_CATALOG_VIEW_MODE_STORAGE_KEY);
    return isSectionsCatalogViewMode(stored) ? stored : "list";
  } catch {
    return "list";
  }
}

export function persistSectionsCatalogViewMode(mode: SectionsCatalogViewMode): void {
  try {
    window.localStorage.setItem(SECTIONS_CATALOG_VIEW_MODE_STORAGE_KEY, mode);
  } catch {
    // Preference is best-effort; a failed write leaves the prior stored mode in place after reload.
  }
}
